export default defineNuxtRouteMiddleware(async (to, from) => {
  const { company, getCompany } = useCompany()

  if (!company.value) {
    await getCompany()
  }
})
